var _circle, _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _circle3, _path13, _path14, _path15, _path16, _path17, _ellipse, _ellipse2, _ellipse3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle4, _path29, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawWindowShoppingRe0Kbm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 820.91776,
    height: 647.1019,
    viewBox: "0 0 820.91776 647.1019",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 799.29779,
    cy: 286.86943,
    r: 13,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.98658,422.95438a8.84237,8.84237,0,0,1-13.09516-3.51489l-31.26288,3.16524,7.57056-14.46787,28.52712-.78768a8.89026,8.89026,0,0,1,8.26036,15.6052Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.77592,437.19343l-68.88664-28.54588a22.31734,22.31734,0,0,1-12.06091-29.12915h0a22.29359,22.29359,0,0,1,32.746-10.156l55.50385,36.0849,57.76287-2.92525,4.32484,17.98811Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "94.851 624.183 105.88 624.183 111.127 581.641 94.849 581.642 94.851 624.183",
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.35034,738.626l17.43511-1.04064v7.47l16.576,11.448a4.666,4.666,0,0,1-2.65139,8.50572H284.953l-3.57781-7.38894-1.397,7.38894h-7.82628Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.89 624.183 34.919 624.183 40.166 581.641 23.888 581.642 23.89 624.183",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.38954,738.626l17.43511-1.04064v7.47l16.57605,11.448a4.666,4.666,0,0,1-2.65139,8.50572H213.99216l-3.57781-7.38894-1.397,7.38894h-7.82628Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.88026,508.79822l43,85.31a23.39,23.39,0,0,1,2.07,15.1,62.4005,62.4005,0,0,1-4,12.74l-5.77,68.46-5.17013,21.4738-18.59989,1.58626s1.44-18-3.6-43.24,3.6-62,3.6-62-15.85-25.94-33.87-38.92S262.88026,508.79822,262.88026,508.79822Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.76026,470.23822s-8.92,15.81-15.51,24.32a38.89006,38.89006,0,0,0-8.25,27.22c.64,7,3.1,14.55,9.35,20.53,0,0,4.32,10.81,2.16,16.58v51.19s-11.56639,60.44266-1.4764,78.46262l4.35641,40.44735s15.29054,4.29145,16.01054-2.90856c0,0,1.99947-15.82142,2.76946-20.87147l.58-51.73a34.4,34.4,0,0,1,6-18.81c3-4.41,6-11.26,6.4-21l23.73-104.87,5.28288-36.63338Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.47878,413.8961l9.22346,46.11762L192.49493,507.126l75.49033-29.10044,1.02494-2.78121,2.49738-9.47136-2.959-29.48927c1.03931-2.16515,15.83447-15.83439.36085-39.86754l-16.71486-39.23243-31.308-.47636-.13.13A63.075,63.075,0,0,0,203.47878,413.8961Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.38949,549.447a8.84236,8.84236,0,0,1-.67744-13.54174L236.09688,507.126l16.09386,2.7605,9.51221,26.906A8.89026,8.89026,0,0,1,249.38949,549.447Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.129,467.97128l6.0061-74.32472a22.31736,22.31736,0,0,1,24.0162-20.42536h0a22.29357,22.29357,0,0,1,19.72354,28.04336l-17.2914,63.90465L261.11017,519.241l-15.79,9.64112Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.50342,359.07731l76.41914-15.62416c2.10444-7.01939,6.13566-13.46482-4.99406-24.42639a33.23405,33.23405,0,0,0-38.05122-26.12023l0,0c-17.54064-1.56112-27.3946,10.90551-27.34372,27.63885Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.83033,
    cy: 202.66101,
    r: 25.97638,
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.48247,300.81344a23.91974,23.91974,0,0,1,15.1285-10.15677l4.89866-1.00155a24,24,0,0,1,28.321,18.70609l0,.00006c-3.5197,4.58363-24.38914,8.057-36.82922,9.57124,3.48379,12.57042,16.87668,22.88426,15.42782,30.52838l-48.98663,10.0155-1.00156-4.89873C177.84658,332.91049,189.83513,311.75417,209.48247,300.81344Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.29142,360.47525l76.41914-15.62416c2.10444-7.01939,6.13566-13.46482-4.99406-24.42639a33.23407,33.23407,0,0,0-38.05122-26.12024l0,0c-17.54065-1.56112-27.3946,10.90551-27.34372,27.63885Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.61833,
    cy: 204.05895,
    r: 25.97638,
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.27047,302.21138a23.91974,23.91974,0,0,1,15.1285-10.15677l4.89866-1.00155a24,24,0,0,1,28.321,18.70609l0,.00006c-3.5197,4.58363-24.38914,8.057-36.82922,9.57124,3.48379,12.57042,16.87668,22.88426,15.42782,30.52838l-48.98663,10.01549-1.00156-4.89872C177.63458,334.30843,189.62313,313.15211,209.27047,302.21138Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M586.847,547.68318H388.71359a20.72929,20.72929,0,0,1-20.70581-20.70605V268.38875a20.72919,20.72919,0,0,1,20.70581-20.70557H586.847a20.7292,20.7292,0,0,1,20.70582,20.70557V526.97713A20.7293,20.7293,0,0,1,586.847,547.68318Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#f0f0f0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M586.84687,548.68279H388.71357A21.73055,21.73055,0,0,1,367.008,526.97673V268.38884a21.73044,21.73044,0,0,1,21.70557-21.70557h198.1333a21.73055,21.73055,0,0,1,21.70605,21.70557V526.97673A21.73065,21.73065,0,0,1,586.84687,548.68279ZM388.71357,248.68327A19.72784,19.72784,0,0,0,369.008,268.38884V526.97673a19.72794,19.72794,0,0,0,19.70557,19.70606h198.1333a19.728,19.728,0,0,0,19.70605-19.70606V268.38884a19.72794,19.72794,0,0,0-19.70605-19.70557Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M908.72872,547.68318H710.59529a20.7293,20.7293,0,0,1-20.70581-20.70605V268.38875a20.7292,20.7292,0,0,1,20.70581-20.70557H908.72872a20.72919,20.72919,0,0,1,20.70581,20.70557V526.97713A20.72929,20.72929,0,0,1,908.72872,547.68318Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#f0f0f0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.15931,156.43609H318.83594a1.0156,1.0156,0,0,1,0-2.0307h684.32337a1.0156,1.0156,0,0,1,0,2.0307Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.95628,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.69836,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.44043,
    cy: 11.16881,
    rx: 10.92534,
    ry: 11.16881,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M980.54613,126.71521H953.72939a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M980.54613,134.33031H953.72939a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M980.54613,141.94541H953.72939a2.03119,2.03119,0,0,1,0-4.06139h26.81674a2.03119,2.03119,0,0,1,0,4.06139Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M920.0297,242.97968l-.0202.018A10.64587,10.64587,0,0,0,904.136,257.15023l-.0202.018,14.18856,15.91393,15.91392-14.18856a10.6603,10.6603,0,0,0-14.18856-15.91393Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#d1d3d4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M421.41729,409.49591a5.60508,5.60508,0,0,1,.02633-4.67218l11.877-25.535a15.58316,15.58316,0,0,1,29.908,8.766l-3.96963,27.9731a5.61114,5.61114,0,0,1-7.14933,4.59123L424.938,412.56851A5.60478,5.60478,0,0,1,421.41729,409.49591Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M550.62262,396.75678l-27.17168,8.05053a5.61112,5.61112,0,0,1-7.14932-4.59123L512.332,372.243a15.58316,15.58316,0,0,1,29.908-8.766l11.877,25.535a5.61112,5.61112,0,0,1-3.49436,7.74478Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M443.72957,373.95315l21.3086-15.49716,34.86861-9.68572L528.964,354.5817l1.70814,16.05655a193.84892,193.84892,0,0,1-2.67671,58.52351l-.70763,14.84241-74.841,2.59193-7.74858-13.56s-17.43431-17.43431-3.8743-36.80576Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M855.80736,343.42284v17.22168l-1.68258,21.039s-.53167,18.3724-1.17455,32.864c-.38868,8.80927-.8254,16.182-1.20633,17.1344-.46811,1.1666-.35728,4.34905-.08719,7.69023.31737,3.86495.84129,7.9442.92848,9.30921.16663,2.54756-1.18269,13.49163-1.18269,13.49163s-1.50781,27.44359-3.698,29.634c-2.19061,2.19037,0,8.42035,0,8.42035-10.26946,7.57117-23.23757-1.68248-23.23757-1.68248,2.86527-4.56334-1.68258-35.71314-1.68258-35.71314s-.66652-10.6346-2.01545-13.49164c-1.34932-2.85708-1.69072-20.70571-1.69072-20.70571V402.19874s-3.53953-5.41253-4.03943-7.93625,0-11.44407,0-11.44407l-3.69841-12.45993-2.53162,9.76158s-6.55516,27.27691-7.73785,30.64192a9.19752,9.19752,0,0,0,.66691,6.73787s1.69033,5.1903,0,7.57117a17.02751,17.02751,0,0,0-2.38088,4.88876s-.86531,9.93616-2.38088,13.49164c-1.51594,3.55542-2.85712,7.93625-2.85712,7.93625s.35689,6.714-1.15867,8.22989c-1.51595,1.51581-2.01584,9.09492-2.01584,9.09492s.33326,8.57909-1.69071,11.61074c-2.02359,3.03166-2.02359,20.20573-2.02359,20.20573a23.55356,23.55356,0,0,1-23.71344,1.00787s2-1.873.484-10.60283c-1.51556-8.72988,1.08736-32.499,1.08736-32.499s-.33326-6.03153,1.34893-8.72988c1.68258-2.6983-.849-7.91242-.17438-10.26952.67466-2.357,2.69825-15.15822,2.69825-15.15822s-.84129-31.48311-.84129-33.16559a21.983,21.983,0,0,0-2.38087-8.587c-1.51556-2.6904,0-22.22151,0-22.22151s3.57131-10.09494,2.38087-12.28531.79363-6.06331.79363-6.06331-1.84921-4.5475,0-5.38875,2.19061-4.2062,2.19061-4.2062l1.28538-16.33283s.48439-7.41243,2.024-7.74574c1.53959-.33336.86493-3.19039,2.38088-5.21412a14.2301,14.2301,0,0,0,1.50781-4.38083c.21429-.93648.4127-1.91262.57933-2.84909.47625-2.53961.77-4.73.77-4.73,9.93621,8.25368,62.18024,2.46817,62.23605,2.46817,3.3171.72222,7.26159,12.23769,10.11058,22.27707A101.26026,101.26026,0,0,1,855.80736,343.42284Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6747,766.9855h29.02c.43018-.78.83008-1.58,1.2002-2.39,3.33984-7.15,4.75-15.13,6.10009-22.95l2.18994-12.7q-10.5,7.635-20.99023,15.26c-2.27979,1.66-4.60986,3.39-6.7998,5.26-4.61036,3.91-8.59034,8.43-10.14991,14.17-.08008.32-.16015.64-.22021.96A19.46461,19.46461,0,0,0,319.6747,766.9855Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#f0f0f0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M315.60488,764.59549a.77469.77469,0,0,0,.00976.15,10.48655,10.48655,0,0,0,.54,2.24H329.185a16.311,16.311,0,0,0,1.03956-2.39,17.49786,17.49786,0,0,0,.85009-3.39,35.21789,35.21789,0,0,0-.67968-11.74c-.25-1.25-.52-2.51-.79-3.75l-1.54-7.08-7.71,12.39C317.7748,755.17551,315.09462,759.74545,315.60488,764.59549Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#f0f0f0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.23476,765.78549a1.19487,1.19487,0,0,0,1.18994,1.2H367.72451a1.195,1.195,0,0,0,0-2.39H184.4247A1.19268,1.19268,0,0,0,183.23476,765.78549Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#cacaca"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.03991,
    cy: 423.99169,
    r: 35.81102,
    fill: "#6c63ff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M479.3893,562.51326a3.98234,3.98234,0,0,1-3.18646-1.59372l-9.76979-13.0266a3.98339,3.98339,0,1,1,6.37357-4.77986l6.39174,8.52166,16.41634-24.62419a3.98356,3.98356,0,1,1,6.629,4.41936l-19.53959,29.30938a3.98517,3.98517,0,0,1-3.204,1.77268C479.46322,562.51261,479.42626,562.51326,479.3893,562.51326Z",
    transform: "translate(-183.23476 -119.8836)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.31812,
    cy: 519.221,
    r: 13,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 529.20761,
    cy: 519.221,
    r: 13,
    fill: "#f2f2f2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.31575,
    cy: 519.221,
    r: 13,
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWindowShoppingRe0Kbm);
export default __webpack_public_path__ + "static/media/undraw_window_shopping_re_0kbm.2f461fe00b0ee0a12f4a57fc7b4bda0e.svg";
export { ForwardRef as ReactComponent };